const BASE_URL = '/collections/all?view=DONTUSEFILTERS';
// Add two helper functions to show and hide the loading animation
function showLoadingAnimation() {
    const loadingAnimation = document.getElementById('loading-animation');
    loadingAnimation.classList.remove('loading-hidden');
}

function hideLoadingAnimation() {
    const loadingAnimation = document.getElementById('loading-animation');
    loadingAnimation.classList.add('loading-hidden');
}
async function fetchDataAndPopulateDropdown() {
    showLoadingAnimation();
    try {
      
        const url = BASE_URL;
        const response = await fetch(url);
        const data = await response.json();
        //console.clear();
        //console.log(url, data);

        // Assume there's only one dropdown with the class 'ymm-dropdown'
        const dropdown = document.querySelector('#filterBrand');
        const categories = new Set(['A1/A2','AK47','M4','Magwell Wraps','MP5','Optics','Phone cases','Pistol Braces','shotguns']);
        populateDropdown(dropdown, data.results[0].values.filter(v => !categories.has(v.label)), data.results[0].label);
        populateDropdown(document.querySelector('#filterCategory'), data.results[0].values.filter(v => categories.has(v.label)), data.results[0].label);

        // Populate another HTML container with the JSON data
        //populateHtmlContainer(data);
    } catch (error) {
        hideLoadingAnimation();
        console.error('Error fetching data:', error);
    }
}

function constructUrl(go = false) {
  
    let url = BASE_URL;
    if(go)
      url = '/collections/all'
    const brand = document.querySelector('#filterBrand');
    const category = document.querySelector('#filterCategory');
    const dropdown = brand.value !== '0' ? brand : category;
    const value = dropdown.value;
    if (value !== "0" && value != null) {
        const key = dropdown.getAttribute('data-param');
      if(go){
        url += `?${key}=${encodeURIComponent(value.replace(/\+/g, ' '))}`;
      }else {
        url += `&${key}=${value.replace(/\s+/g, '+')}`;
      }
    }
    return url;
}

function populateDropdown(dropdown, values, label) {
    dropdown.innerHTML = `<option value="0">${dropdown.dataset.placeholder}</option>`;
   
    if(values.length)
      dropdown.setAttribute('data-param', values[0].param_name);
    
    values.forEach(value => {
        if (value.count > 0) {
            const option = document.createElement('option');
            option.value = value.value.replace(/\s+/g, '+');
            option.textContent = `${value.label} (${value.count})`; // Display count next to label
            dropdown.appendChild(option);
        }
    });
    dropdown.disabled = false;
    hideLoadingAnimation();
}

function populateHtmlContainer(data) {
    const container = document.querySelector('#product-grid-custom');
    
    // Check if the data has the 'search_results' and 'results' properties
    if(data.search_results.results_count && data.search_results.results_count > 0) {
        // Clear previous content
        container.innerHTML = '';
        // The result is a string of HTML, so we can directly assign it
        container.innerHTML = data.search_results.results;
    } else {
        // Handle the case where the expected data is not present
        console.error('Invalid data structure:', data);
        container.innerHTML = '<h2>No results found.</h2>';
    }
    hideLoadingAnimation();
}

async function fetchDataAndPopulateHtml() {
    showLoadingAnimation();
    
    try {
        const url = constructUrl();
        const response = await fetch(url);
        const data = await response.json();
        //console.clear();
        //console.log(url, data);
        populateHtmlContainer(data);
    } catch (error) {
        hideLoadingAnimation();
        console.error('Error fetching data:', error);
    }
}

document.getElementById('data-search').addEventListener('change', function(event) {
    if (event.target.classList.contains('custom-dropdown')) {
        const other = event.target.id === 'filterBrand' ? 'filterCategory' : 'filterBrand';
        document.getElementById(other).value = '0';
        document.querySelector('#product-grid-custom').innerHTML = '';
        fetchDataAndPopulateHtml();
    }
});

document.querySelector('.brand-search').addEventListener('click', function() {
    const url = constructUrl(true);
    window.location.assign(url);
});

// Call the function to populate the dropdown on page load
window.addEventListener('DOMContentLoaded', (event) => {
    fetchDataAndPopulateDropdown();
});
